// @ts-nocheck
import PropTypes from 'prop-types';
import { addTravelDays } from '../../../../../utils/travelDate';
import { useFlags } from 'launchdarkly-react-client-sdk';
import TravelDocLineItemDisplay from '../../../../LineItem/Display/TravelDocLineItemDisplay';
import './LineItemServiceSection.css';

const LineItemServiceSection = ({
  lineItem,
  tenantsettings,
  startdate,
  daynumber
}) => {
  const { itineraryNavigation } = useFlags();

  const { servicetypecode = '', enddayoffset = 0 } = lineItem;

  // Calculate start and end dates for services when in itinerary navigation mode
  let startDate = null;
  let endDate = null;

  if (itineraryNavigation && startdate && daynumber) {
    startDate = addTravelDays(startdate, parseInt(daynumber, 10) - 1);
    const daysToAdd = enddayoffset || 0;

    if (servicetypecode === 'HTL') {
      endDate = addTravelDays(startDate, parseInt(daysToAdd, 10));
    } else if (daysToAdd > 0) {
      endDate = addTravelDays(startDate, parseInt(daysToAdd, 10));
    } else {
      endDate = startDate;
    }
  }

  // Augment lineitem with calculated fields for display
  const augmentedLineItem = {
    ...lineItem,
    ...(startDate && { startDate }),
    ...(endDate && { endDate })
  };

  const { bodyfont } = tenantsettings || {};

  return (
    <div style={{ fontFamily: bodyfont /*,minHeight: '150px'*/ }}>
      <TravelDocLineItemDisplay
        lineItem={augmentedLineItem}
        tenantsettings={tenantsettings}
      />
    </div>
  );
};

LineItemServiceSection.propTypes = {
  lineItem: PropTypes.object.isRequired,
  tenantsettings: PropTypes.object,
  startdate: PropTypes.string,
  daynumber: PropTypes.number
};

export default LineItemServiceSection;
